module.exports = __webpack_public_path__ + "static/media/qr-code.5b20a7d5.svg";